<template>
  <ClientOnly>
    <div class="gc-panel">
      <!--blackjack top part-->
      <div v-if="isBlackjack" class="gc-panel__line-live-game-info">
        <SvgIcon
          v-for="seat in 7"
          :key="seat"
          class="gc-panel__icon-plus"
          :class="{ 'green': liveTableData[`seat${seat}`] }"
          :name="liveTableData[`seat${seat}`] ? 'common/profile-plus' : 'common/profile'"
        />
      </div>
      <!--roulette top part-->
      <div v-if="isRoulette" class="gc-panel__line-live-game-info gc-panel__roulette-info">
        <UiText
          class="gc-panel__roulette-recent-text"
          type="cards"
          font="text-m"
          color="gray-200"
          :text="$tc('recentWin')"
        />
        <div class="gc-panel__roulette-info-right">
          <UiText
            v-for="(resObj, i) in rouletteLastResults"
            :key="resObj.time + i"
            class="gc-panel__roulette-info-win"
            :class="{
              'red': resObj.color === 'red',
              'green': resObj.color === 'green',
              'black': resObj.color !== 'red' && resObj.color !== 'green',
            }"
            type="cards"
            font="caption"
            color="gray-50"
            bold
            :text="resObj.result"
          />
        </div>
      </div>

      <div class="gc-panel__info-wrap">
        <div class="gc-panel__info-main">
          <img
            v-if="cardData.provider && cardData.provider.iconUrl"
            class="gc-panel__logo-provider"
            :src="`${$config.cloudUrl}${cardData.provider.iconUrl}`"
            alt="pic"
          />

          <UiText
            class="gc-panel__panel-name"
            font="body-text-small"
            :text="cardData.name"
            color="typography-title01"
          />
        </div>

        <UiText
          v-if="cardData.minBet"
          font="body-text-small"
          color="primary-500"
          :text="minBetText"
          class="gc-panel__minbet"
        />
      </div>

      <div v-if="liveTableData.usersText" class="gc-panel__line">
        <div class="gc-panel__live-info">
          <SvgIcon class="gc-panel__live-info-icon" name="account/profiles" />
          <div>{{ liveTableData.usersText }}</div>
        </div>
      </div>
    </div>
  </ClientOnly>
</template>
<script>
import { formatNumberFilter } from '~/util/helpers/vueFilters'

export default {
  name: 'LargeCardPanel',
  props: {
    cardData: { type: Object, required: true },
    liveTableData: { type: Object, required: true },
  },
  computed: {
    isRoulette() {
      return this.liveTableData?.tableType?.isRoulette
    },
    rouletteLastResults() {
      return this.liveTableData?.last20Results || []
    },
    isBlackjack() {
      return this.liveTableData?.tableType?.isBlackjack
    },
    minBetText() {
      const minBet = this.liveTableData.minBetGrn || `${formatNumberFilter(this.cardData.minBet, { format: 'grn' })}`
      if (!minBet) return ''
      return `${this.$t('from')} ${minBet}`
    },
  },
}
</script>
<style lang="scss" src="./style.scss" scoped />
